export default __webpack_public_path__ + "static/media/Room_4.165d1173.png";